import type { RecommendedProductDTOType } from '../../../../store/stylesSearch/schemas';

const normalizeStyleNumber = (value: unknown): string => {
  if (typeof value === 'string') {
    return value.trim();
  }
  if (typeof value === 'number') {
    return value.toString();
  }
  return '';
};

export const getInitialSelection = (
  mode: 'recommendations' | 'selection',
  currentSelectedIds: Array<string | number>,
  currentMappedIds: Array<string | number>,
): Array<string> =>
  (mode === 'selection' ? currentSelectedIds : currentMappedIds)
    .map(value => String(value))
    .filter(Boolean);

export const getInitialSelectedImages = (
  currentMappedImages: Record<string, string | object | undefined>,
): Record<string, string> =>
  Object.fromEntries(
    Object.entries(currentMappedImages).filter(
      (entry): entry is [string, string] => typeof entry[1] === 'string',
    ),
  );

export const getProductStyleNumbers = (product: RecommendedProductDTOType): Array<string> => {
  const productWithUnknownFields = product as unknown as {
    lk_style_number?: unknown;
  };
  const styleNumbers = Array.isArray(productWithUnknownFields.lk_style_number)
    ? productWithUnknownFields.lk_style_number.map(normalizeStyleNumber)
    : [normalizeStyleNumber(productWithUnknownFields.lk_style_number)];

  return Array.from(new Set(styleNumbers.filter(Boolean)));
};

export const hasSelectionChanged = (
  selectedProducts: Array<string>,
  initialSelectedProducts: Array<string>,
): boolean => {
  const current = Array.from(new Set(selectedProducts));
  const initial = Array.from(new Set(initialSelectedProducts));

  if (current.length !== initial.length) {
    return true;
  }

  const initialSet = new Set(initial);
  return current.some(id => !initialSet.has(id));
};
